const solicitar_retrato_de_matricula_inicial = {
  path: "/solicitar-retrato-de-matricula-inicial",
  redirect: "/solicitar-retrato-de-matricula-inicial",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Gerar o Retrato da Matrícula",
  },
  children: [
    {
      path: "/solicitar-retrato-de-matricula-inicial",
      name: "solicitar-retrato-de-matricula-inicial",
      component: () =>
        import(
          "@/views/SolicitarRetratoDeMatriculaInicial/SolicitarRetratoDeMatriculaInicialHome.vue"
        ),
    },
  ],
};

export { solicitar_retrato_de_matricula_inicial };
